import { createContext, useCallback, useContext, useMemo, useState } from 'react';

/**
 * Global state for the "quick expense" bottom sheet.
 *
 * Used by Despesas, cofres e rotas que abrem o registo rápido (`open()`).
 */
const ExpenseSheetContext = createContext(null);

export function ExpenseSheetProvider({ children }) {
  const [isOpen, setOpen] = useState(false);
  const [presetCategoryId, setPresetCategoryId] = useState(null);
  // CHANGE v2 §24: pre-fill do cofre quando o utilizador clica "Depositar".
  const [presetSavingsPotId, setPresetSavingsPotId] = useState(null);

  const open = useCallback((categoryId = null, options = {}) => {
    setPresetCategoryId(categoryId);
    setPresetSavingsPotId(options.savingsPotId ?? null);
    setOpen(true);
  }, []);

  const close = useCallback(() => {
    setOpen(false);
    setPresetCategoryId(null);
    setPresetSavingsPotId(null);
  }, []);

  const value = useMemo(
    () => ({ isOpen, presetCategoryId, presetSavingsPotId, open, close, setOpen }),
    [isOpen, presetCategoryId, presetSavingsPotId, open, close],
  );

  return (
    <ExpenseSheetContext.Provider value={value}>
      {children}
    </ExpenseSheetContext.Provider>
  );
}

export function useExpenseSheet() {
  const ctx = useContext(ExpenseSheetContext);
  if (!ctx) {
    throw new Error('useExpenseSheet must be used inside <ExpenseSheetProvider>');
  }
  return ctx;
}
